import { render, staticRenderFns } from "./ShapeElement.vue?vue&type=template&id=d0cc8974&scoped=true&"
import script from "./ShapeElement.vue?vue&type=script&lang=js&"
export * from "./ShapeElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cc8974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0cc8974')) {
      api.createRecord('d0cc8974', component.options)
    } else {
      api.reload('d0cc8974', component.options)
    }
    module.hot.accept("./ShapeElement.vue?vue&type=template&id=d0cc8974&scoped=true&", function () {
      api.rerender('d0cc8974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Elements/ShapeElement.vue"
export default component.exports